export default "__VITE_ASSET__CfD$OMio__"